import { useEffect, useState } from 'react';
import Select, { SingleValue } from 'react-select';

import { ShiftTypes } from '~modules/tabel/interfaces/shift-types';

interface ShiftTypeSelectProps {
	defaultValue?: ShiftTypes;
	isDisabled?: boolean;
	isClearable?: boolean;
	onChange: (value: keyof typeof ShiftTypes | null) => void;
	onBlur?: () => void;
}

type ShiftOption = {
	value: keyof typeof ShiftTypes;
	label: string;
};

const shiftOptions = Object.entries(ShiftTypes).map(([value, label]) => ({
	value: value as keyof typeof ShiftTypes,
	label,
}));

export const ShiftTypeSelect = ({ defaultValue, isDisabled, isClearable, onChange, onBlur }: ShiftTypeSelectProps) => {
	const getKeyByValue = (value: ShiftTypes): keyof typeof ShiftTypes | null => {
		const entry = Object.entries(ShiftTypes).find(([_, val]) => val === value);
		return entry ? (entry[0] as keyof typeof ShiftTypes) : null;
	};

	const findOptionByValue = (enumValue: keyof typeof ShiftTypes): ShiftOption | null => {
		return shiftOptions.find(option => option.value === enumValue) || null;
	};

	const defaultKey = defaultValue ? getKeyByValue(defaultValue) : null;

	useEffect(() => {
		setSelectedOption(defaultKey ? findOptionByValue(defaultKey) : null);
	}, [defaultKey]);

	const [selectedOption, setSelectedOption] = useState<SingleValue<ShiftOption>>(
		defaultKey ? findOptionByValue(defaultKey) : null,
	);

	const handleChange = (newValue: SingleValue<ShiftOption>) => {
		setSelectedOption(newValue);
		onChange?.(newValue?.value || null);
	};

	return (
		<div className="select-container">
			<Select
				isClearable={isClearable}
				isDisabled={isDisabled}
				onChange={handleChange}
				onBlur={onBlur}
				value={selectedOption}
				defaultValue={null}
				placeholder="Вид"
				options={shiftOptions}
				noOptionsMessage={() => 'Нет доступных опций'}
			/>
		</div>
	);
};
